// Remove language switcher if no languages are available

document.querySelectorAll('ul.wpml-ls-sub-menu').forEach((ul) => {
	if (ul.children.length === 0) {
		const parent = ul.closest('div.wpml-ls');
		
		if (parent) {
			parent.style.display = 'none';
		}
	}
});